import styled, { css } from 'styled-components';

const verticalStyles = ({ vertical }) =>
  vertical &&
  css`
    flex: auto;
  `;

export default styled.div`
  flex: 1;
  overflow: hidden;
  overflow-y: auto;
  ${verticalStyles}
`;
